const mEditionMapActivationSendingOfDeliverablesEdit = {
  mEditionMapActivationSendingOfDeliverablesEdit: {
    alerts: {
      updateContenidoEntregable: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El entregable fue editado exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      asunto: {
        label: 'Asunto',
        message: '* De 5 a 255 caracteres'
      },

      dia: {
        label: 'Día de entrega'
      },

      entrega: {
        label: 'Tipo de entrega'
      },

      mensaje: {
        label: 'Mensaje'
      }
    },

    validation: {
      asunto: {
        maxLength: 'La longitud máxima permitida es de 255 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Asunto de entregable es requerido. De 5 a 255 caracteres.'
      },

      dia: {
        minLength: 'La cantidad mínima permitida es de 0 días.',
        required: 'Día de entrega es requerido.'
      },

      entrega: {
        required: 'Tipo de entrega es requerido.'
      },

      mensaje: {
        required: 'Mensaje de entregable es requerido.'
      }
    }
  }
}

export default mEditionMapActivationSendingOfDeliverablesEdit
